import { types } from "../action-types";

const getInitials = (fullName = "") => {
  const parts = fullName.trim().split(" ").filter(Boolean);
  if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`;
  if (parts.length === 1) return parts[0][0];
  return "?";
};

const normalizeItem = (item) => ({
  _id: item.profile_id,
  id: item.profile_id,
  name: item.full_name || "",
  title: item.title || item.headline || "",
  avatar: item.profile_picture_url || null,
  initials: getInitials(item.full_name),
  online: false,
  aiScore: null,
  totalExperience: item.totalExperience
    ? `${item.totalExperience} yr${item.totalExperience !== 1 ? "s" : ""}`
    : "",
  location: item.location || item.country || "",
  estimatedAmount: "",
});

const initialState = {
  isActive: false,
  loading: false,
  error: false,
  data: [],
  totalCount: 0,
  displayedTotalCount: 0,
  pageSize: 25,
  appliedFilters: null,
};

const nlSearchExternalReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.NL_SEARCH_EXTERNAL_INIT:
      return { ...state, isActive: true, loading: true, error: false, errorMessage: null };

    case types.NL_SEARCH_EXTERNAL_SUCCESS: {
      const inner = action.payload?.data || action.payload;
      const profiles = Array.isArray(inner?.profiles)
        ? inner.profiles
        : Array.isArray(action.payload)
        ? action.payload
        : [];
      const totalCount = inner?.metadata?.total ?? inner?.metadata?.total_results ?? profiles.length;
      const pageSize = inner?.metadata?.per_page ?? inner?.metadata?.page_size ?? 25;
      return {
        ...state,
        isActive: true,
        loading: false,
        error: false,
        data: profiles.map(normalizeItem),
        totalCount,
        displayedTotalCount: totalCount,
        pageSize,
        appliedFilters: inner?.appliedFilters || null,
        errorMessage: null,
      };
    }

    case types.NL_SEARCH_EXTERNAL_FAILURE:
      return {
        ...state,
        isActive: true,
        loading: false,
        error: true,
        errorMessage: action.payload?.errorMessage || action.payload || null,
        errorType: action.payload?.errorType || null,
      };

    case types.NL_SEARCH_EXTERNAL_CLEAR:
      return { ...initialState };

    default:
      return state;
  }
};

export default nlSearchExternalReducer;
